import { WebSocketMessage } from "../../services/websocket.service";

export function buildOnboardingPotentialCasesMessage(
  payload: WebSocketMessage,
): string {
  const result = (payload["result"] as Record<string, unknown>) || {};
  const totalAmount = Number(result["totalAmountPotential"] ?? 0);
  const totalQuantity = Number(result["totalQuantityPotential"] ?? 0);
  const potentialCases = (result["potentialCases"] ?? []) as Array<{
    quantity: number;
  }>;

  const casesWithQuantity = potentialCases.filter(
    (claimCase) => claimCase.quantity > 0,
  );

  const claimsText = totalQuantity === 1 ? "claim" : "claims";
  return `${totalQuantity} ${claimsText} found across ${casesWithQuantity.length} types. Total: $${totalAmount.toFixed(2)}`;
}
